import * as React from 'react';
import '../tw.css';
import { useTranslation } from "react-i18next";
import ImgCenteredCaption from '../Components/ImgCenteredCaption';
import PersonCard from '../Components/PersonCard';
import { GetBodyFontClass, GetHeaderFontClass } from '../Helper/Helper';
import Data from "../Local/en/trustees.json";

export default function TrusteesPage(){
    const { t } = useTranslation("trustees");
    let trusteesData = Data.team;
    let trustees = Object.keys(trusteesData);

    return <div className='mb-10'>
        <ImgCenteredCaption imageSrc={"https://lccccompany.blob.core.windows.net/public/trustees.jpg"} alt="Trustees">
            <h1 className={`md:text-6xl text-2xl text-center text-white ${GetHeaderFontClass()}`}>{t('title')}</h1>
            <p className={`md:text-2xl text-lg text-center text-white mt-5 ${GetBodyFontClass()}`}>{t('subTitle')}</p>
        </ImgCenteredCaption>
        {trustees && trustees.filter(x=>t(`team.${x}.name`) != "").map((trustee,index) => {
            return <PersonCard title={t(`team.${trustee}.title`)} inverse={index % 2 == 0} titleClassNames={GetHeaderFontClass()} imgSrc={t(`team.${trustee}.image`)}>
                <p className={GetBodyFontClass()}>{t(`team.${trustee}.name`)}</p>
                <p className={GetBodyFontClass()}>{t(`team.${trustee}.description`)}</p>
            </PersonCard>
        })}
    </div>
}
